import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { CommonLayout } from '../../commonComponents';
import SecurityExclusionMgmt from '.';
import AuditHistory from './AuditHistory';

const routerList = [
    {
        name: 'Security Exclusion Management',
        path: "",
        component: SecurityExclusionMgmt,
    },
    {
        name: "Audit History",
        path: "audit-history",
        component: AuditHistory,
    }
]


function Routes(): JSX.Element {
    const { path } = useRouteMatch();

    return (
        <Switch>
            {
                routerList.map((item, index) => <Route
                    exact
                    key={index}
                    path={`${path}/${item.path}`}
                    component={item.component}
                />)
            }
        </Switch>
    );
}

export default function SecExclusionMgmtRouter(): JSX.Element {

    return (
        <CommonLayout>
            <Routes />
        </CommonLayout>
    )
}
